import React, { useState } from "react";
import { Box, Typography, Button } from "@mui/material";
import Popup from "../../../components/customHelpers/Popup";
import ChangeCustomer from "../../../components/forms/customers";
import Notification from "../../../components/customHelpers/Notification";
import Notify from "../../../components/customHelpers/Notify";

const PropertyRow = ({ label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      mb: 0.5,
      "& > :last-child": { ml: 1.5 },
    }}
  >
    <Typography
      sx={{
        fontWeight: "bold",
        color: "text.secondary",
        mr: 1,
        fontSize: 12,
        minWidth: 60,
      }}
    >
      {label}
    </Typography>
    <Typography sx={{ color: "text.secondary", fontSize: 12 }}>
      {value ?? "N/A"}
    </Typography>
  </Box>
);

const CustomerDetails = ({ product, title, getOrderData, change, id }) => {
  const [openPopupChange, setOpenPopupChange] = useState(false);
  const { NotifyMessage, notify, setNotify } = Notify();
  const isPrinting = window.location.pathname.includes("print");

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        p: 2,
        maxHeight: 250,
        minWidth: 200,
        overflow: "hidden",
        borderRadius: 1,
      }}
    >
      {product.customer && (
        <>
          <Typography
            sx={{
              fontWeight: "bold",
              color: "primary.main",
              mb: 1,
              fontSize: 14,
            }}
          >
            {title ?? "Bill To"}
          </Typography>

          <PropertyRow label="Name" value={product.customer.fullName} />
          <PropertyRow label="Email" value={product.customer.email} />
          <PropertyRow label="Phone" value={product.customer.phoneNo} />
          <PropertyRow label="Location" value={product.customer.location} />
          <PropertyRow label="Address" value={product.customer.address} />
          <PropertyRow label="Contact" value={product.customer.contact} />
        </>
      )}

      {change && !isPrinting && (
        <Button
          variant="contained"
          color="primary"
          sx={{ mt: 0.5, textTransform: "capitalize", fontSize: 12, px: 1, py: 0.5 }}
          onClick={() => setOpenPopupChange(true)}
        >
          Change Customer
        </Button>
      )}

      <Popup
        title="Change Customer"
        openPopup={openPopupChange}
        setOpenPopup={setOpenPopupChange}
      >
        <ChangeCustomer
          NotifyMessage={NotifyMessage}
          id={id}
          setOpenPopupBulkSave={setOpenPopupChange}
          getOrderData={getOrderData}
          setOpenPopup={setOpenPopupChange}
        />
      </Popup>

      <Notification notify={notify} setNotify={setNotify} />
    </Box>
  );
};

export default CustomerDetails;
